import React, { useEffect } from "react";
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router-dom";

export const SyncTabToURL: React.FC<{
  meterPointId: string;
  meterId: string;
}> = ({ meterPointId, meterId }) => {
  const { replace } = useHistory();
  const { path, url } = useRouteMatch();
  const { accountNumber, propertyId } = useParams();

  useEffect(() => {
    const p = path.includes("/meters") ? path : path + "/meters/:meterId";
    const target = generatePath(p, {
      accountNumber,
      propertyId,
      meterPointId,
      meterId,
    });

    /* istanbul ignore else */
    if (target !== url) {
      replace(target);
    }
  }, [accountNumber, propertyId, meterPointId, meterId, path, url, replace]);

  return null;
};
